import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Home, FileText, Zap, Store, Settings } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useTenant } from '../../contexts/TenantContext';

// Mobile bottom tab bar — visible only below 768px (see index.css
// `.mobile-bottom-nav` media query). Desktop sidebar is already hidden
// below 1024px via Layout.js's `hidden lg:flex`, which covers <768px too.
const MobileNav = () => {
  const { isAdmin } = useAuth();
  const { buildPath } = useTenant();
  const location = useLocation();
  const navigate = useNavigate();

  const items = [
    { key: 'home', label: 'Home', icon: Home, path: buildPath('/dashboard'), show: true },
    { key: 'quotes', label: 'Quotes', icon: FileText, path: buildPath('/quotations'), show: true },
    { key: 'ai-quote', label: 'AI Quote', icon: Zap, path: buildPath('/ai-quotes'), show: true },
    { key: 'masters', label: 'Masters', icon: Store, path: buildPath('/admin/masters'), show: isAdmin },
    { key: 'settings', label: 'Settings', icon: Settings, path: buildPath('/admin/settings'), show: isAdmin },
  ].filter((item) => item.show);

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(`${path}/`);

  return (
    <nav className="mobile-bottom-nav" data-testid="mobile-bottom-nav">
      {items.map((item) => {
        const active = isActive(item.path);
        const Icon = item.icon;
        return (
          <button
            key={item.key}
            type="button"
            className="mobile-bottom-nav-item"
            onClick={() => navigate(item.path)}
            data-testid={`mobile-nav-${item.key}`}
            aria-current={active ? 'page' : undefined}
          >
            <Icon
              className="mobile-bottom-nav-icon"
              style={{ color: active ? '#0A1F44' : '#9CA3AF' }}
            />
            <span
              className="mobile-bottom-nav-dot"
              style={{ opacity: active ? 1 : 0 }}
            />
          </button>
        );
      })}
    </nav>
  );
};

export default MobileNav;
